import { FormProvider } from "react-hook-form";
import { Icon, IconType } from "../../../../common/icons/Icon";
import {
  IUseWorkoutStatisticsArgs,
  useWorkoutStatistics,
} from "./hooks/useWorkoutStatistics";
import { StatisticsPeriodSelector } from "./components/StatisticsPeriodSelector";
import { SummaryCards } from "./components/SummaryCards";
import { MuscleDistributionRadar } from "./components/MuscleDistributionRadar";
import { VolumePerWorkoutChart } from "./components/VolumePerWorkoutChart";
import { SetsRepsPerWorkoutChart } from "./components/SetsRepsPerWorkoutChart";
import { FrequencyChart } from "./components/FrequencyChart";
import styles from "./WorkoutStatistics.module.scss";

/**
 * The "Статистика" tab on the My Workouts page. A date range (defaulted to the last
 * week) drives a single aggregated request; below it every statistic is stacked on one
 * scroll — summary cards, the muscle-distribution radar, and per-workout / frequency
 * bar charts.
 */
export const WorkoutStatistics = (props: IUseWorkoutStatisticsArgs) => {
  const { rangeForm, statistics, hasData, isLoading } =
    useWorkoutStatistics(props);

  return (
    <div className={styles.root}>
      <FormProvider {...rangeForm}>
        <StatisticsPeriodSelector
          dateFromName="dateFrom"
          dateToName="dateTo"
          maxDate={new Date()}
        />
      </FormProvider>

      {isLoading ? (
        <div className={styles.skeletons}>
          {Array(4)
            .fill(0)
            .map((_, index) => (
              <div className={styles.skeleton} key={index} />
            ))}
        </div>
      ) : !hasData || !statistics ? (
        <div className={styles.empty}>
          <div className={styles.empty_orb}>
            <Icon
              type={IconType.Dumbell}
              width="28px"
              height="28px"
              color="rgba(180, 178, 235, 0.95)"
            />
          </div>
          <h2 className={styles.empty_title}>Няма данни за този период</h2>
          <p className={styles.empty_description}>
            Изберете друг период или завършете тренировка, за да видите
            статистика.
          </p>
        </div>
      ) : (
        <div className={styles.content}>
          <SummaryCards summary={statistics.summary} />
          <MuscleDistributionRadar breakdown={statistics.muscleBreakdown} />
          <VolumePerWorkoutChart perWorkout={statistics.perWorkout} />
          <SetsRepsPerWorkoutChart perWorkout={statistics.perWorkout} />
          <FrequencyChart weeklyFrequency={statistics.weeklyFrequency} />
        </div>
      )}
    </div>
  );
};
